/** Route paths for the Tests module (relative to module base path) */
export const TESTS_ROUTES = {
  MCTS: "mcts",
  CYOT: "cyot",
  ILTS: "ilts",
  PYPS: "pyps",
  CWTS: "cwts",
  SCORE: "score",
  SCORE_REGISTER: "score/register",
  REVISION_TEST: "revision-tests",
  DETAIL: "page2",
  GENERAL_INSTRUCTIONS: "general-instructions",
  EXAM: "exam",
  TEST_FINISH: "test-finish",
  SOLUTIONS: "solutions",
  SUBJECTIVE_SOLUTIONS: "subjective-solutions",
  UPLOAD_ANSWER_SHEET: "upload-answer-sheet",
  UPLOAD_ANSWER_PDF: "upload-answer-pdf",
  PDF_PREVIEW: "pdf-preview",
  REPORT: "report",
  CALCULATION_SCORE: "calculation-score",
  WIZKLUB: "wizklub",
} as const;
